import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customerId',
  standalone: true,
})
export class CustomerIdPipe implements PipeTransform {
  public transform(value: string): string | null {
    if (!value) {
      return null;
    }

    const numeric = Number(value.trim());
    if (isNaN(numeric) || value.includes(',') || value.includes('.')) {
      return 'child-onboarding.legal-guardian-2.customer-id.error.nan';
    }

    if (numeric < 1000000) {
      return 'child-onboarding.legal-guardian-2.customer-id.error.min';
    }

    if (numeric > 9999999) {
      return 'child-onboarding.legal-guardian-2.customer-id.error.max';
    }

    return null;
  }
}
